// @flow weak

import { teal, indigo, pink, deepPurple, grey, red, blue, black, white } from './colors';

export const light = {
  text: {
    primary: grey[600],
    light: grey[430],
    button: teal.A350,
    today: teal[420],
    secondary: '#afafaf',
    hint: 'rgba(0, 0, 0, 0.38)',
    icon: 'rgba(0, 0, 0, 0.38)',
    divider: 'rgba(0, 0, 0, 0.12)',
    lightDivider: 'rgba(0, 0, 0, 0.075)',
    warning: pink.A250,
    lightCreditCard: '#8f9499',
  },
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.26)',
  },
  background: {
    default: grey[50],
    hover: grey[130],
    menuHover: teal[80],
    paper: white,
    appBar: grey[100],
    contentFrame: grey[200],
    status: grey[300],
    userIcon: teal.A350,
    progressBar: grey[360],
    disabled: grey[300],
    calendarHover: teal[90],
    checkbox: grey[180],
    budget: grey[170],
  },
  colors: {
    border: grey[300],
    borderDark: grey.A120,
    borderButton: teal.A350,
    thumbUp: teal.A350,
    thumbDown: pink.A250,
    borderLight: grey[190],
    icon: grey[330],
    iconDisabled: grey[350],
    white,
    todoPlaceholder: '#f7f7f7',
    error: red[400],
    cost: blue[520],
  },
  link: {
    active: '#00c5c1',
  },
  triangle: {
    border: '#E1E1E1',
  },
  tooltip: {
    shadow: 'rgba(0, 0, 0, 0.2)',
    border: grey[100],
  },
  candidate: {
    border: '#D7D7D7',
    shadow: 'rgba(0, 0, 0, 0.1)',
    tabInactive: '#1ac5c0',
    tabsBorder: '#e0e0e0',
    tabsBackgroundColor: '#F7F7F7',
    marker: blue[520],
  },
  jobOpening: {
    active: grey[130],
    hover: teal[80],
    progress: deepPurple[350],
    disqualified: pink.A250,
  },
  account: {
    background: '#239aa0',
    tabsBorder: grey[360],
    hint: '#CBCBCB',
    disabled: '#efefee',
  },
};

export const dark = {
  // we don't have dark theme atm, feel free to add one if needed
};

export const shades = { dark, light };

export function getContrastText(color: string) {
  // if (getContrastRatio(color, black) < 7) {
  //   return dark.text.primary;
  // }
  return light.text.primary;
}

export default function createPalette({ primary = indigo, accent = pink, error = red, type = 'light' } = {}) {
  return {
    type,
    ...shades[type],
    shades,
    primary,
    accent,
    error,
    grey,
    // functions
    getContrastText,
  };
}

export { createPalette };
